import axios from "axios";
import { Subscription } from "types/Subscription";

export interface GetSubscriptionStatusResponse {
  SubscriptionId: string;
  CustomerId: string;
  PATIENTID: string;
  Subscription_Status: string;
  ProductName: string;
  NextPurchaseDate: string | null;
  PlanPeriodicity: string | null;
  PlanInterval: number;
  imageUrl: string | null;
  Cycle_Status: string | null;
}

export const getSubscriptionStatusRequest = async (
  PatientID: string
): Promise<Subscription[]> => {
  try {
    const { data } = await axios.get<GetSubscriptionStatusResponse[]>(
      `/api/v1/patient_subscriptions?patient_id=${PatientID}`
    );
    return data.map((pref) => ({
      subscriptionId: pref.SubscriptionId,
      customerId: pref.CustomerId,
      patientID: pref.PATIENTID,
      subscriptionStatus: pref.Subscription_Status,
      productName: pref.ProductName,
      planPeriodicity: pref.PlanPeriodicity?.toLowerCase() || "",
      nextPurchaseDate: pref.NextPurchaseDate || "",
      planInterval: pref.PlanInterval,
      imageUrl: pref.imageUrl || "",
      cycleStatus: pref.Cycle_Status || "",
    }));
  } catch (err) {
    return [];
  }
};
